import { Component, OnInit } from "@angular/core";
@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
})
export class HomeComponent implements OnInit {
  dataText = [
    "Hi there, I am  Vikas Gupta.",
    "A Frontend Engineer.",
    "Total 6+ Year of experience",
    "includes StencilJS, Angular ..",
    "also React."
  ];
  currentText = "";
  constructor() {}

  ngOnInit(): void {
    // start the text animation
    this.StartTextAnimation(0);
  }
  // keeps calling itself until the text is finished
  typeWriter(text: string, i: number, fnCallback: any): void {
    // chekc if text isn't finished yet
    if (i < text.length) {
      // add next character to h1
      this.currentText = text.substring(0, i + 1);
      // wait for a while and call this function again for next character
      setTimeout(() => {
        this.typeWriter(text, i + 1, fnCallback);
      }, 50);
    } else if (typeof fnCallback === "function") {
      // call callback after timeout
      setTimeout(fnCallback, 1000);
    }
  }
  // start a typewriter animation for a text in the dataText array
  StartTextAnimation(i: number): void {
    // check if dataText[i] exists
    const textArrayLast = this.dataText.length;
    if (this.dataText[i] && i < this.dataText[i].length) {
      // text exists! start typewriter animation
      this.typeWriter(this.dataText[i], 0, () => {
        // after callback (and whole text has been animated), start next text
        if (textArrayLast === i + 1) {
          i = -1;
        }
        this.StartTextAnimation(i + 1);
      });
    }
  }
}
